import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import ConditionalImage from 'components/shared/ConditionalImage';

export const DesignElement = ({ alt, arrowStyles, url, chooseElement }) => (
  <span
    className={styles.optionWrapper}
    onTouchStart={chooseElement}
    onClick={chooseElement}
  >
    <ConditionalImage
      altText={alt}
      className={styles.optionIcon}
      imgUrl={url}
    />
    <span className={arrowStyles} />
  </span>
);

export default enhance(DesignElement);
